import type { AppLanguage } from '../i18n/types';
import type { MessageKey } from '../i18n/messages';
import { assetRecordDisplayTitle } from '../components/AssetGetByIdView';
import {
  assetListingSortPrice,
  sortAssetBrowseListRecords,
  type AssetListingSortPrice,
} from '../utils/assetBrowseListSort';
import type { AssistantPriceSort } from './parseAssistantPriceSort';

type TranslateFn = (key: MessageKey, params?: Record<string, string | number>) => string;

export function formatAssetListingSortPrice(price: AssetListingSortPrice, language: AppLanguage): string {
  const amount = Number.isInteger(price.amount) ? String(price.amount) : price.amount.toFixed(2);
  if (language === 'he') {
    const unit = price.unit === 'hour' ? 'לשעה' : price.unit === 'day' ? 'ליום' : 'לחודש';
    return `₪${amount} ${unit}`;
  }
  return `₪${amount} per ${price.unit}`;
}

/** “The cheapest is X — ₪80 per hour.” for the rows now on screen. */
export function assistantPriceSortReply(
  rows: Record<string, unknown>[],
  sort: AssistantPriceSort,
  t: TranslateFn,
  language: AppLanguage,
): string {
  const top = sortAssetBrowseListRecords(rows, sort, { language })[0];
  const price = top ? assetListingSortPrice(top) : null;
  if (!top || !price) {
    return t('assistant.result.priceSortNoPrice');
  }
  return t(sort === 'priceDesc' ? 'assistant.result.mostExpensive' : 'assistant.result.cheapest', {
    name: assetRecordDisplayTitle(top),
    price: formatAssetListingSortPrice(price, language),
  });
}
